// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__366Tn","close":"icon_close__1qoGi icon_icon__366Tn","check":"icon_check__307Nm icon_icon__366Tn"};